import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'

import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'
import Stepper from 'react-stepper-horizontal';

import { } from '../actions'
import { } from '../utils'

class FinishOrder extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <Row>
                        <Col xs={0} sm={2} md={2}>
                        </Col>
                        <Col xs={12} sm={8} md={8}>
                            <div>
                                <Stepper
                                    activeColor='#F37232'
                                    completeColor='#F37232'
                                    circleFontSize={14}
                                    circleTop={15}
                                    size={30}
                                    steps={[{ title: 'ตรวจสอบรายการสินค้าในตะกร้า' },
                                    { title: 'เลือกวิธีจัดส่ง' },
                                    { title: 'วิธีชำระเงิน' },
                                    { title: 'สั่งซื้อเรียบร้อย' }]}
                                    activeStep={3} />
                            </div>
                        </Col>
                        <Col xs={0} sm={2} md={2}>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={0} sm={2} md={4}>
                        </Col>
                        <Col xs={12} sm={8} md={4}>
                            <img className="img-responsive" src="../../static/images/logo_songsod_blue.png" style={{ width: '100%', marginBottom: 20, marginTop: 60, paddingLeft: 100, paddingRight: 100 }} />
                            <h4 style={{ textAlign: 'center' }}>ขอขอบคุณที่วางใจใช้บริการส่งสดค่ะ</h4>
                            <h3 style={{ color: '#f57224 !important', marginBottom: 20, textAlign: 'center' }}>"กรุณารอสักครู่ พนักงานส่งสดกำลังจะติดต่อไปหาลูกค้านะคะ"</h3>
                            <Row>
                                <Col xs={6} sm={6} md={6}><button className='btn btn-primary pull-right' style={{ width: '100%', marginBottom: 70 }} onClick={() => { this.props.history.push('/') }}>กลับไปชอปปิ้งต่อ</button></Col>
                                <Col xs={6} sm={6} md={6}><button className='btn btn-primary pull-left' style={{ width: '100%', marginBottom: 70 }} onClick={() => { this.props.history.push('/orderhistory') }}>ไปหน้าประวัติการสั่งซื้อ</button></Col>
                            </Row>
                        </Col>
                        <Col xs={0} sm={2} md={4}>
                        </Col>
                    </Row>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }

}

// function mapStateToProps(state) {
//     return {
//         delivery_time: state.delivery_time_reducer
//     }
// }

export default connect(null, {})(FinishOrder)


// WEBPACK FOOTER //
// ./src/components/page_finished_order.js